<script>
    import {
        Chart as ChartJS,
        CategoryScale,
        LinearScale,
        BarElement,
        Title,
        Tooltip,
        Legend,
        Colors
    } from 'chart.js';
    import { Bar } from 'vue-chartjs';

    import ChartDataLabels from 'chartjs-plugin-datalabels';

    ChartJS.register(
        CategoryScale,
        LinearScale,
        BarElement,
        Title,
        Tooltip,
        Legend,
        Colors,
        ChartDataLabels,
    );

    // Import general mixin for shared functionality.
    import mixin from '../../mixin';

    export default {
        mixins: [mixin],
        components: {
            Bar,
        },
        props: {
            data: Object,
            phase: Object,
        },
        data() {
            return {
                facetAlias: 'fase_label_aantal_dagen_doorlooptijd_lopend',
                options: {
                    locale: 'nl-NL',
                    maintainAspectRatio: false,
                    scales: {
                        y: {
                            title: {
                                display: true,
                                text: this.$store.getters.getText('dashboardWidgetAmount'),
                            }
                        },
                        x: {
                            title: {
                                display: true,
                                text: this.$store.getters.getText('dashboardWidgetTurnarounddays'),
                            },
                            grid: {
                                display: false
                            },
                        }
                    },
                    plugins: {
                        legend: {
                            display: false,
                        },
                        tooltip: {
                            callbacks: {
                                label: (context) => `${context.label}: ${context.parsed._custom.barEnd - context.parsed._custom.barStart}`
                            },
                        },
                        datalabels: {
                            formatter: (value, ctx) => value[1] - value[0],
                            color: '#ffffff',
                        }
                    },
                },
            };
        },
        computed: {
            facetsSet() {
                return this.data && this.data.facets && this.data.facets.length;
            },
            dataSets() {
                const defaultValue = { labels: [], datasets: [] };
                if (!this.facetsSet) return defaultValue;
                const facet = this.data.facets.find(f => f.alias === this.facetAlias);
                if (!facet || !facet.options || !facet.options.length) return defaultValue;
                const options = facet.options.filter(o => o.valueAlias.includes(this.phase.label));
                if (!options.length) return defaultValue;

                const turnAroundTimes = ['0-30', '31-90', '91-180', '181-360', '>360'];
                let offset = 0;

                const dataset = turnAroundTimes.map(time => {
                    const valueAlias = this.getValueAliasByTime(time);
                    const option = options.find(o => o.valueAlias.includes(valueAlias));
                    const count = option ? option.filteredAmount : 0;

                    const dataPoint = {
                        label: time,
                        backgroundColor: this.phase.backgroundColor,
                        data: [offset, offset + count],
                    };

                    offset += count;

                    return dataPoint;
                });

                dataset.push({
                    label: this.$store.getters.getText('dashboardLabelTotal'),
                    backgroundColor: '#00447A',
                    data: [0, offset],
                });

                return {
                    labels: dataset.map(time => time.label),
                    datasets: [{
                        data: dataset.map(time => time.data),
                        backgroundColor: dataset.map(time => time.backgroundColor),
                    }],
                };
            },
            computedOptions() {
                return {
                    ...this.options,
                    plugins: {
                        ...this.options.plugins,
                        title: {
                            display: true,
                            text: this.phase.label
                        },
                    },
                };
            }
        },
        methods: {
            getValueAliasByTime(time) {
                switch (time) {
                    case '0-30':
                        return '0.30';
                    case '31-90':
                        return '31.90';
                    case '91-180':
                        return '91.180';
                    case '181-360':
                        return '181.360';
                    case '>360':
                        return '360+';
                    default:
                        return '';
                }
            },
        }
    };
</script>

<template>
    <div class="dashboard-widget dashboard-widget--minheight">
        <Bar :data="dataSets" :options="computedOptions" />
    </div>
</template>
